import { createContext } from "react";

export const Context = createContext(
  {} as {
    setStep: (step: number) => void;
    currentStep: number;
  }
);
